import {
  populatedCampaignSchema,
  type PopulatedCampaign,
} from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import * as z from "zod";

export const getCampaignById = {
  name: "getCampaignById" as const,
  description:
    "Fetch a single campaign's full detail by id. Use before updateCampaign to see current fields; list campaigns first with getTeamCampaigns.",
  mutates: false,
  input: z.object({ id: z.string() }),
  output: populatedCampaignSchema as z.ZodType<PopulatedCampaign>, // TODO (Josh) remove cast when Zod is fixed
};
